document.addEventListener("DOMContentLoaded", function () {
    const activeClasses = {
        button: "filter-sellers__item-button--active",
        grid: "best-sellers__body-wrapper--active",
    };
    const subTitle = document.querySelector(".headlines-sellers__subtitle");
    const filterButtons = document.querySelectorAll(".filter-sellers__item-button");
    const listCollection = document.querySelectorAll(".best-sellers__body-wrapper");
    const listRecommendations = document.querySelectorAll(".best-sellers__body-wrapper[data-url]")

    filterButtons.forEach(button => button.addEventListener("click", setActiveCollection));

    listRecommendations.forEach(list => {
        getRecommendationProducts(list, list.dataset.url)
    })


    function setActiveCollection() {
        if (!this instanceof HTMLButtonElement) return;

        const { dataset: { value }, textContent } = this;
        removeSpecialClass(filterButtons, activeClasses.button);
        removeSpecialClass(listCollection, activeClasses.grid);

        this?.classList.add(activeClasses.button);

        const selectedCollection = findCollection(listCollection, "data-value", value) || listCollection[0];

        selectedCollection?.classList.add(activeClasses.grid);

        setCorrectSubTitle(subTitle, textContent);
    }

    function removeSpecialClass(array, nameClass) {
        array.forEach(elementArray => elementArray.classList.remove(nameClass));
    }

    function findCollection(array, nameAttr, valueAttr) {
        return [...array].find(elementArray => elementArray.getAttribute(nameAttr) === valueAttr);
    }

    function setCorrectSubTitle(htmlElement, text) {
        if (htmlElement && text) {
            htmlElement.innerHTML = text;
        }
    }

    async function getRecommendationProducts(productsWrapper, url) {
        const res = await fetch(url)
        if (!res.ok || !productsWrapper) return;

        const productsText = await res.text();
        const productsHTML = new DOMParser().parseFromString(productsText, 'text/html')?.querySelector('.best-sellers__body-wrapper .best-sellers__body-inner')

        productsWrapper.querySelector('.best-sellers__body-inner').innerHTML = productsHTML.innerHTML;
        productsWrapper.swiper?.update()
    }
});
